<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="Title" prop="title" >
        <a-input v-model="form.title" placeholder="Please enter title" />
      </a-form-model-item>
      <a-form-model-item label="Content" prop="content" >
        <editor v-model="form.content" />
      </a-form-model-item>
<!--      <a-form-model-item label="Sort" prop="sort" >-->
<!--        <a-input v-model="form.sort" placeholder="Please enter sort value" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="Status: 0-Off 1-On" prop="status" >-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="Remark" prop="remark" >-->
<!--        <a-input v-model="form.remark" placeholder="Please enter content" type="textarea" allow-clear />-->
<!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            Save
          </a-button>
          <a-button type="dashed" @click="cancel">
            Cancel
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getHelp, addHelp, updateHelp } from '@/api/system/help'
import Editor from '@/components/Editor'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // Form fields
      form: {
        id: null,

        title: null,

        content: null,

        sort: null,

        status: null,

        createTime: null,

        remark: null,

      },
      // 1 add, 2 edit
      formType: 1,
      open: false,
      rules: {
        title: [
          { required: true, message: 'Title is required', trigger: 'blur' }
        ],
        content: [
          { required: true, message: 'Content is required', trigger: 'blur' }
        ],
        sort: [
          { required: true, message: 'Sort is required', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // Cancel button
    cancel () {
      this.open = false
      this.reset()
    },
    // Reset form
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        title: null,
        content: null,
        sort: null,
        status: null,
        createTime: null,
        remark: null,
      }
      // this.$nextTick(() => {
      //   if(this.$refs.form){
      //     this.$refs.form.resetFields()
      //   }
      // })
    },
    /** Add action */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = 'Add'
    },
    /** Edit action */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getHelp({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = 'Edit'
      })
    },
    /** Submit */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateHelp(this.form).then(response => {
              this.$message.success(
                'Updated successfully',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addHelp(this.form).then(response => {
              this.$message.success(
                'Added successfully',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
